import { SharedVariable } from "@core/model/SharedVariable";
import { UIService } from "@core/services/UIService";
import { cid, container } from "inversify-props";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { CommissionRecordsService, IncomeDeductiblesDTO, NewIncomeDeductiblesItems } from '../../CommissionModule/api'

const sharedVariable = container.get<SharedVariable>(cid.SharedVariable);
const uiService = sharedVariable.uiService
  ? sharedVariable.uiService
  : new UIService();

@Module({ namespaced: true, name: "PaymentVoucherStore" })
export default class PaymentVoucherStore extends VuexModule {
  loading = false;
  list = [];
  voucherCodeList = [];
  total = 0;

  @Action({ rawError: true })
  async fetchIncomeDeductibles({ page, limit, search }) {
    try {
      this.context.commit('setLoading', true)
      const response =
        await CommissionRecordsService.allIncomeDeductibles({
          page,
          limit,
          search,
        });
      this.context.commit('setList', response);
      this.context.commit('setLoading', false)
    } catch (error) {
      await uiService.alert.show({
        type: "error",
        message: error.message,
      });
    }
  }

  @Action({ rawError: true })
  async fetchVoucherCodeList() {
    try {
      const response =
        await CommissionRecordsService.getVoucherCode();
      this.context.commit('setVoucherCodeList', response);
    } catch (error) {
      await uiService.alert.show({
        type: "error",
        message: error.message,
      });
    }
  }

  @Mutation
  setLoading(value: boolean) {
    this.loading = value;
  }

  @Mutation
  setList({ data, recordsTotal }) {
    this.list = data;
    this.total = recordsTotal;
  }

  @Mutation
  setVoucherCodeList(data) {
    this.voucherCodeList = data;
  }
}
